import {HttpContextToken, HttpErrorResponse} from '@angular/common/http';
import {OneOrArrayOf} from '@aviary/store/utility-type.helpers';
import {Action} from '@ngrx/store';
import {ApiErrorCode} from '@aviary/store/common/common.types';

export const FAKE_ERROR_RESPONSE: HttpContextToken<FakeHttpErrorResponse> = new HttpContextToken(() => undefined);

export type FakeHttpErrorResponse = ApiErrorCode | HttpErrorResponse | undefined;

export const CUSTOM_ERROR_HANDLERS_CREATOR: HttpContextToken<CustomErrorHandlersCreator> = new HttpContextToken(() => (() => ({})));

export type CustomErrorHandlersCreator = (errorResponse: HttpErrorResponse) => CustomErrorHandlers;  // Some actions need information from the error response.

export interface CustomErrorHandlers {
  [status: number]: CustomErrorHandler;
}

export interface CustomErrorHandler {
  discardOriginalErrorResponse: boolean;
  actionMappers: ErrorActionMapper[];
}

export interface ErrorActionMapper {
  errorCodes: OneOrArrayOf<ApiErrorCode>;
  actions: OneOrArrayOf<Action>;
}

// UI-ready string to display in a snack bar instead of the error code string itself.  OR an array with the UI-ready string AND a redirection route name.
export type Error400Handler<RouteNameType extends string = string> = string | [string, RouteNameType];

export type Error400Handlers<RouteNameType extends string = string> = {
  [apiErrorCode in ApiErrorCode]: Error400Handler<RouteNameType>;
};

export const REFRESH_AND_TRY_AGAIN_ERROR_MESSAGE = 'Please refresh and try again. If the problem persists, contact your library staff.';
export const AUTH_PATRON_MISSING_MESSAGE = `User information not found. ${REFRESH_AND_TRY_AGAIN_ERROR_MESSAGE}`;
